module.exports = __webpack_public_path__ + "img/725-unit.bfd92107.png";